(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/frejaeid/other-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/frejaeid/other-device.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.frejaeid.OtherDevice = Marionette.View.extend({
    template: function template(data) {
      return svs.player_login.templates.ssn_login(data);
    },
    behaviors: function behaviors() {
      var behaviors = [{
        behaviorClass: svs.player_login.behaviors.FrejaEidErrorHandling
      }];

      if (!this.options.model.get('hideUsernameLogin')) {
        behaviors.push({
          behaviorClass: svs.player_login.behaviors.UsernameLogin
        });
      }

      return behaviors;
    },
    ui: {
      loginButton: '.js-frejaeid-login',
      backButton: '.js-back-to-frejaeid'
    },
    events: {
      'click @ui.loginButton': 'onLoginClick',
      'click @ui.backButton': 'onBackButtonClick'
    },
    onBackButtonClick: function onBackButtonClick() {
      svs.player_login.router.navigate('/', true);
    },
    onLoginClick: function onLoginClick(e) {
      var _this = this;

      !!e && e.preventDefault();
      svs.player_login.radio.request('authRef').done(function (authRef) {
        _this.model.set('authRef', authRef);

        svs.player_login.router.navigate("frejaeidpoll?authref=".concat(authRef, "&ofd=true"), true);
      }).fail(function (err) {
        _this.triggerMethod('frejaEidError', err);
      });
    }
  });
})(Backbone, _, svs);
 })(window);